/*
 * author: szp
 * tips: 图片/PDF 上传组件，支持直接打开预览
 * createdTime: 2019/08/12
 * */

import React, { PureComponent } from 'react';
import { Modal, message, Upload, Icon } from 'antd';
import { getVariantSession, LOGIN_TOKEN } from '@Variant';
import _ from 'lodash';
import { generateUrl } from '@util';
import { API_POST_UPLOAD } from '@api';

const PDF_THUMB =
  'data:image/svg+xml;charset=UTF-8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96"><rect width="96" height="96" rx="8" fill="#fff1f0"/><path d="M28 18h26l14 14v46a4 4 0 0 1-4 4H28a4 4 0 0 1-4-4V22a4 4 0 0 1 4-4z" fill="#ff4d4f"/><path d="M54 18v14h14" fill="#ff7875"/><text x="48" y="61" font-size="20" text-anchor="middle" fill="#ffffff" font-family="Arial">PDF</text></svg>',
  );

export default class UploadImagePdf extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      previewUpload: {
        previewVisible: false,
        previewImage: '',
      },
    };
  }

  getAccept = () => this.props.accept || '.jpg, .png, .gif, .bmp, .webp, .jpeg, .pdf';

  isBlobUrl = url => typeof url === 'string' && url.indexOf('blob:') === 0;

  getRemoteUrl = file => {
    if (file.response?.data?.url) return file.response.data.url;
    if (file.response?.data) return file.response.data;
    if (file.url && !this.isBlobUrl(file.url)) return file.url;
    return '';
  };

  getFileUrl = file => {
    const remoteUrl = this.getRemoteUrl(file);
    if (remoteUrl) return remoteUrl;
    if (file.url) return file.url;
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
    return '';
  };

  isPdfFile = file => {
    const fileName = (file.name || '').toLowerCase();
    const fileUrl = (file.url || '').toLowerCase();
    return (
      file.type === 'application/pdf' || /\.pdf(\?|$)/.test(fileName) || /\.pdf(\?|$)/.test(fileUrl)
    );
  };

  getFileName = file => {
    if (file.name && file.name !== 'image.png') return file.name;
    const fileUrl = this.getFileUrl(file);
    if (!fileUrl) return this.isPdfFile(file) ? 'pdf文件.pdf' : 'image.png';
    const cleanUrl = fileUrl.split('?')[0];
    const urlName = cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    return decodeURIComponent(urlName || (this.isPdfFile(file) ? 'pdf文件.pdf' : 'image.png'));
  };

  normalizeFileItem = item => {
    const remoteUrl = this.getRemoteUrl(item);
    return {
      ...item,
      ...(this.isPdfFile(item)
        ? {
            thumbUrl: item.thumbUrl || PDF_THUMB,
            name: this.getFileName(item),
          }
        : {}),
      url: remoteUrl || undefined,
    };
  };

  normalizeFileList = fileData => {
    const currentFileList = fileData || [];
    return currentFileList.map(item => this.normalizeFileItem(item));
  };

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  handleCancel = () => {
    this.setState({
      previewUpload: {
        previewVisible: false,
        previewImage: '',
      },
    });
  };

  handlePreview = async file => {
    if (!this.isPdfFile(file)) {
      let previewImage = this.getFileUrl(file);
      if (!previewImage && file.originFileObj) {
        previewImage = await this.getBase64(file.originFileObj);
      }
      if (!previewImage) {
        message.error('图片地址不存在，暂时无法预览');
        return;
      }
      this.setState({
        previewUpload: {
          previewVisible: true,
          previewImage,
        },
      });
      return;
    }
    const fileUrl = this.getFileUrl(file);
    if (!fileUrl) {
      message.error('文件地址不存在，暂时无法预览');
      return;
    }
    window.open(fileUrl);
  };

  beforeUpload = file => {
    const { maxSize } = this.props;
    let judge = [true, ''],
      fileAccept = false;

    const config = {
        maxSize: maxSize || 2,
      },
      accept = this.getAccept().replace(/\s*/g, '').toLowerCase().split(','),
      fileNameParts = file.name.toLowerCase().split('.');

    accept.forEach(item => {
      if (item === '.' + fileNameParts[fileNameParts.length - 1]) fileAccept = true;
    });
    if (!fileAccept) judge = [false, '只允许上传图片或PDF文件'];

    if (file.size / 1024 / 1024 > config.maxSize) {
      judge = [false, `上传文件超过${config.maxSize}Mb`];
    }
    if (!judge[0]) {
      message.error(judge[1]);
      return false;
    }
  };

  handleChange() {}

  render() {
    const { previewUpload } = this.state;
    const {
      action,
      onChange,
      beforeUpload,
      fileData,
      maxLength,
      name,
      fileTips,
      fileList,
      isShowDel,
      ...props
    } = this.props;
    let url;
    const fileData_ = fileData ? fileData : [];
    const normalizedFileData = this.normalizeFileList(fileData_);
    const hasPdfFile = normalizedFileData.some(item => this.isPdfFile(item));
    if (action) {
      const { searchParams, urlParams, replaceParams, api } = action;
      url = _.isObject(action) ? generateUrl(api, searchParams, urlParams, replaceParams) : action;
    } else {
      url = generateUrl(API_POST_UPLOAD);
    }
    const settings = {
      name: name ? name : 'multipartFile',
      showUploadList: true,
      action: url,
      headers: { 'login-token': getVariantSession(LOGIN_TOKEN), 'X-Requested-With': null },
      listType: 'picture-card',
      beforeUpload: beforeUpload || this.beforeUpload,
      onPreview: this.handlePreview,
      onChange: file => {
        if (file.file && file.file.status) {
          const nextFileList = file.fileList.map(item => this.normalizeFileItem(item));
          const nextFile = {
            ...file,
            file: this.normalizeFileItem(file.file),
            fileList: nextFileList,
          };
          (onChange && onChange(nextFile)) || this.handleChange(nextFile);
        }
      },
    };
    return (
      <div style={{ position: 'relative', float: 'left', width: '100%' }}>
        <Upload
          {...props}
          {...settings}
          fileList={normalizedFileData}
          showUploadList={{ showRemoveIcon: isShowDel ? false : true }}
          accept={this.getAccept()}>
          {normalizedFileData.length >= maxLength ? null : (
            <div>
              <Icon type="plus" />
              <div className="ant-upload-text">Upload</div>
            </div>
          )}
        </Upload>
        <div style={{ position: 'absolute', bottom: '-20px' }}>{fileTips ? fileTips : ''}</div>
        {/* {hasPdfFile ? (
          <div
            style={{
              marginTop: 12,
              clear: 'both',
              display: 'flex',
              flexWrap: 'wrap',
              width: '100%',
            }}>
            {normalizedFileData.map(item => (
              <div
                key={item.uid || item.name || item.url}
                style={{
                  width: 104,
                  marginRight: 8,
                  lineHeight: '20px',
                  wordBreak: 'break-all',
                  color: this.isPdfFile(item) ? '#1890ff' : 'transparent',
                  cursor: this.isPdfFile(item) ? 'pointer' : 'default',
                }}>
                {this.isPdfFile(item) ? (
                  <span onClick={() => this.handlePreview(item)}>{this.getFileName(item)}</span>
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            ))}
          </div>
        ) : null} */}
        <Modal visible={previewUpload.previewVisible} footer={null} onCancel={this.handleCancel}>
          <img alt="example" style={{ width: '100%' }} src={previewUpload.previewImage} />
        </Modal>
      </div>
    );
  }
}
